export const MIDDLEWARE_BASE_API_URL = '/_api/loyalty-middleware';
